!(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
})(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
);

(async function () {
    try {
        const handle = window.ShopifyStore?.handle ?? "";
        const response = await fetch(
            `https://goho.work/api/Track/Pixel?handle=${handle}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                signal: AbortSignal.timeout(5000), // 5秒超时自动取消
            }
        );

        // 处理HTTP层错误
        if (!response.ok) {
            throw new Error(`HTTP错误 ${response.status}`);
        }

        // 【修改这里】使用 .text() 替代 .json()，防止大数精度丢失
        const textData = await response.text();
        
        // 去除首尾可能存在的不可见字符（空格、换行等），确保纯净
        const pixelId = textData.trim();
        fbq("init", pixelId);
        fbq("track", "PageView");
		// 判断是否为商品页面 (URL 包含 /products/ 且不是 fetch 请求)
		if (window.location.pathname.includes('/products/')) {
            fbq('track', 'ViewContent', getProductDataForPixel());
		}
    } catch (error) {
        console.error("PixelId获取失败:", error);
    }
})();

// 缓存数据
let viewProduct = [];

document.addEventListener("DOMContentLoaded", function () {
    // 是否为首页
    let isHome = true;
    let productList = document.querySelector("#product-grid");
    if (productList) {
        let products = productList.querySelectorAll("li");

        // 存储已观察的商品 ID
        const observedProductIds = new Set();

        // 获取本地缓存中已存储的商品 ID（如果有）
        const viewProductData =
            JSON.parse(localStorage.getItem("viewProduct")) || [];

        // 判断数据结构是否合法
        if (Array.isArray(viewProductData)) {
            // 老数据格式：仅包含数组，没有时间戳
            localStorage.removeItem("viewProduct"); // 清空老数据
        } else if (viewProductData && viewProductData.timestamp) {
            // 判断是否有时间戳并且是否过期 (超过24小时为过期)
            const currDateTime = new Date(getCurrentDateTime()); // 当前时间
            const recordDateTime = new Date(viewProductData.timestamp); // 记录时间

            // 计算时间差（以小时为单位）
            const timeDiffInHours =
                (currDateTime - recordDateTime) / (1000 * 60 * 60);

            if (timeDiffInHours > 24) {
                // 超过 24 小时，清空数据
                localStorage.removeItem("viewProduct");
            } else {
                // 未过期，提取数组部分
                viewProduct = viewProductData.productIds || [];
            }
        } else {
            // 数据异常，清空
            localStorage.removeItem("viewProduct"); // 清空异常数据
        }

        // 创建交叉观察者，用于检测商品是否进入可视区域
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 获取商品 ID
                        const productId = entry.target.getAttribute("data-product-id");

                        // 将商品 ID 存入 Set 中，自动去重
                        observedProductIds.add(productId);

                        // 停止观察该商品项，避免重复发送请求
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                root: productList, // 使用商品列表作为观察区域
                threshold: 0.75, // 商品至少需要75%进入视口才会触发
                rootMargin: "0px 0px 0px 0px", // 不提前触发
            }
        );

        // 页面加载时，开始观察所有已经可见的商品项
        const observeNewProducts = () => {
            // 更新 products 列表，获取懒加载后新增的商品元素
            products = productList.querySelectorAll("li");

            // 对所有商品进行观察
            products.forEach((product) => {
                const rect = product.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    observer.observe(product); // 如果商品项已进入视口，开始观察
                }
            });
        };

        // 初始加载时，观察页面上所有可见的商品项
        observeNewProducts();

        // 监听页面的滚动事件，动态添加观察新的商品项
        let timeout;
        window.addEventListener("scroll", () => {
            clearTimeout(timeout); // 清除上次的定时器
            timeout = setTimeout(() => {
                observeNewProducts(); // 延迟执行 observeNewProducts
            }, 200); // 200ms内没有滚动事件发生时，执行观察
        });

        // 每 5 秒输出一次已观察的商品 ID
        setInterval(() => {
            if (observedProductIds.size > 0) {
                // 从 Set 中获取未发送的商品 ID
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );

                // 清空已观察的商品 ID
                observedProductIds.clear();

                // 如果有新商品 ID
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 获取当前域名（从地址栏）
                    const currentDomain = window.ShopifyStore?.handle ?? "";

                    // 请求接口，获取当前的域名和商品 ID
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }

                // 清空已观察的商品 ID
                observedProductIds.clear();
            }
        }, 5000); // 每5秒请求一次

        // 页面跳转、关闭时发送未发送的商品 ID
        window.addEventListener("beforeunload", () => {
            if (observedProductIds.size > 0) {
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 设置缓存id
                    setLocalStorage(uniqueProductIds);

                    // 请求接口，获取当前的域名和商品 ID
                    const currentDomain = window.ShopifyStore?.handle ?? "";
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }
            }
        });

        // 页面卸载时（确保即使在不支持 beforeunload 的浏览器中也能发送请求）
        window.addEventListener("unload", () => {
            if (observedProductIds.size > 0) {
                const newProductIds = Array.from(observedProductIds).filter(
                    (productId) => !viewProduct.includes(productId)
                );
                if (newProductIds.length > 0) {
                    // 合并本地缓存 viewProduct 和已观察的商品 ID，并去重
                    const uniqueProductIds = Array.from(
                        new Set([...viewProduct, ...newProductIds])
                    );

                    // 设置缓存id
                    setLocalStorage(uniqueProductIds);

                    // 请求接口，获取当前的域名和商品 ID
                    const currentDomain = window.ShopifyStore?.handle ?? "";
                    sendProductIdsToBackend(
                        currentDomain,
                        newProductIds,
                        "View",
                        uniqueProductIds
                    );
                }
            }
        });
    }
});

// 选择需要监听的目标节点（购物车菜单）
const cartParentElement = document.querySelector("#CartDrawer");
if (cartParentElement) {
    cartParentElement.addEventListener("click", async function (event) {
        // 判断事件目标是否是按钮且是否具有目标 class
        if (
            event.target &&
            event.target.classList.contains("cart__checkout-button")
        ) {
            // 阻止按钮的默认点击事件
            event.preventDefault();
            // 阻止事件冒泡（如果有必要）
            event.stopPropagation();

            // loading 开
            updateLoadingStatus(true);

            const cartData = await fetchCartData(); // 等待 fetchCartData 完成

            // 请求结算接口
            sendCart(cartData);
        }
    });
}

// 控制loading遮罩的显隐
function updateLoadingStatus(isOff) {
    if (isOff) {
        // loading 开
        document.querySelector(".preloader").style.opacity = "1";
        document.querySelector(".preloader").style.backgroundColor = "#fff";
        document.querySelector(".preloader").style.zIndex = "9999";
    } else {
        // loading 关
        document.querySelector(".preloader").style.opacity = "0";
        document.querySelector(".preloader").style.backgroundColor = "transparent";
        document.querySelector(".preloader").style.zIndex = "-9999";
    }
}
// 获取指定cookie值
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : null;
}

// 设置指定cookie值
function setCookieValue(name, value, minutes) {
    document.cookie = `${name}=${value}; expires=${new Date(
        minutes
    ).toUTCString()}; path=/`;
}

// 请求接口记录商品id数据
function sendProductIdsToBackend(domain, productIds, action, uniqueProductIds) {
    if (typeof fbq === "function") {
        if (action === "AddToCart") {
            // 对应加入购物车 (AddToCart)
            fbq("track", "AddToCart", {
                content_ids: productIds,
                content_type: "product",
            });
        }
    }

    // 获取pid
    var pids = getCookieValue("pid");
    var pidStr = "";
    if (pids) {
        pidStr = "?pid=" + pids;
    }

    // 使用 sendBeacon 在页面关闭时发送数据
    const data = JSON.stringify({
        domain: domain,
        list: productIds,
        reff: document.referrer,
    });

    // 使用 sendBeacon 发送数据
    if (navigator.sendBeacon) {
        const isSuccess = navigator.sendBeacon(
            "https://goho.work/api/Track/" + action + pidStr,
            data
        );
        // 如果成功，更新本地缓存 View才需要更新
        if (isSuccess) {
            if (action == "View") {
                // 设置缓存id
                setLocalStorage(uniqueProductIds);
                //localStorage.setItem('viewProduct', JSON.stringify(uniqueProductIds));

                viewProduct = uniqueProductIds;
            }
        } else {
            console.error("发送数据失败");
        }
    } else {
        // 如果浏览器不支持 sendBeacon，使用 fetch 替代
        fetch("https://goho.work/api/Track/" + action, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include", // 发送跨域请求时包含Cookie
            body: data,
        })
            .then((response) => response.json())
            .then((data) => {
                // 只有返回状态为 OK，才更新缓存
                if (data.status === "OK") {
                    if (action == "View") {
                        // 设置缓存id
                        setLocalStorage(uniqueProductIds);
                        // localStorage.setItem('viewProduct', JSON.stringify(uniqueProductIds));
                        viewProduct = uniqueProductIds;
                    }
                } else {
                    console.error("接口返回失败:", data);
                }
            })
            .catch((error) => {
                console.error("商品 ID 提交失败:", error);
            });
    }
}

// 设置缓存
function setLocalStorage(item) {
    // 获取当前时间
    const currentTime = getCurrentDateTime();

    const storageData = {
        productIds: item,
        timestamp: currentTime,
    };

    // 存入 localStorage
    localStorage.setItem("viewProduct", JSON.stringify(storageData));
}

// 根据类型设置缓存
function updateLocalStorageByType(productId, type) {
    // 获取当前时间
    const currentTime = getCurrentDateTime();

    const typeProductData =
        JSON.parse(localStorage.getItem(type + "Product")) || [];
    var currData = [];
    if (typeProductData && typeProductData.timestamp) {
        // 判断是否有时间戳并且是否过期 (超过24小时为过期)
        const currDateTime = new Date(getCurrentDateTime()); // 当前时间
        const recordDateTime = new Date(typeProductData.timestamp); // 记录时间

        // 计算时间差（以小时为单位）
        const timeDiffInHours = (currDateTime - recordDateTime) / (1000 * 60 * 60);

        if (timeDiffInHours > 24) {
            // 超过 24 小时，清空数据
            localStorage.removeItem(type + "Product");
        } else {
            // 未过期，提取数组部分
            currData = typeProductData.productIds || [];
        }
    } else {
        // 数据异常，清空
        localStorage.removeItem(type + "Product"); // 清空异常数据
    }

    // 是否重复
    var isRepetition = true;
    var findData = currData.find((x) => x == productId);
    if (!findData) {
        // 追加
        currData.push(productId);
        isRepetition = false;
    }
    var storageData = {
        productIds: currData,
        timestamp: currentTime,
    };

    // 存入 localStorage
    localStorage.setItem(type + "Product", JSON.stringify(storageData));
    // 返回是否重复
    return isRepetition;
}

// 获取当前时间
const getCurrentDateTime = () => {
    const now = new Date(); // 当前时间
    const year = now.getUTCFullYear(); // UTC 年
    const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // UTC 月（+1）
    const day = String(now.getUTCDate()).padStart(2, "0"); // UTC 日
    const hours = String(now.getUTCHours()).padStart(2, "0"); // UTC 小时
    const minutes = String(now.getUTCMinutes()).padStart(2, "0"); // UTC 分钟
    const seconds = String(now.getUTCSeconds()).padStart(2, "0"); // UTC 秒
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
};
// 获取未来某分钟数后的时间
const getFutureDateTime = (minutesToAdd) => {
    const now = new Date(); // 当前时间
    now.setUTCMinutes(now.getUTCMinutes() + minutesToAdd); // 增加指定的分钟数
    const year = now.getUTCFullYear(); // UTC 年
    const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // UTC 月（+1）
    const day = String(now.getUTCDate()).padStart(2, "0"); // UTC 日
    const hours = String(now.getUTCHours()).padStart(2, "0"); // UTC 小时
    const minutes = String(now.getUTCMinutes()).padStart(2, "0"); // UTC 分钟
    const seconds = String(now.getUTCSeconds()).padStart(2, "0"); // UTC 秒
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
};
// 获取时间戳
function getTimestamp() {
    return Date.now();
}

// 调用cart接口发送订单
function sendCart(items) {
    // 如果购物车为空，则刷新页面
    if (items.items.length == 0) {
        location.href = location.href;
        return;
    }

    // [修改] 优化 InitiateCheckout 事件，携带商品和价值数据
    if (typeof fbq === "function" || typeof window.fbq === "function") {
        // 构建标准的 Pixel 数据结构
        var initiateCheckoutData = {
            currency: items.currency, // 币种
            value: items.total_price / 100, // 金额 (Shopify通常以分回传，需除以100)
            content_type: "product",
            contents: [],
        };
        // 填充 contents 数组
        if (items.items && items.items.length > 0) {
            for (let i = 0; i < items.items.length; i++) {
                initiateCheckoutData.contents.push({
                    id: items.items[i].product_id,
                    quantity: items.items[i].quantity,
                });
            }
        }
        fbq("track", "InitiateCheckout", initiateCheckoutData);
    } else if (
        typeof sendEvent === "function" ||
        typeof window.sendEvent === "function"
    ) {
        sendEvent("InitiateCheckout", "track");
    }

    // 获取pid
    var pids = getCookieValue("pid");
    var pidStr = "";
    if (pids) {
        pidStr = "?pid=" + pids;
    }

    // 获取 _fbp, _fbc, ttclid 三个值
    const fbp = getCookieValue("_fbp");
    const fbc = getCookieValue("_fbc");
    const ttclid = getCookieValue("ttclid");
    const url = window.location.href;
    const handle = window.ShopifyStore?.handle || null;
    items.fbp = fbp || null;
    items.fbc = fbc || null;
    items.ttclid = ttclid || null;
    items.url = url || null;
    items.handle = handle;

    // 构建发送请求的 data
    const data = JSON.stringify(items);

    // 发送请求
    fetch("https://goho.work/api/Order/Cart" + pidStr, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include", // 发送跨域请求时包含Cookie
        body: data,
    })
        .then((response) => response.json())
        .then((res) => {
            // 只有返回状态为 OK，才更新缓存
            if (res.Succeeded) {
                // 成功
                // loading 关
                //updateLoadingStatus(false);

                // 成功则清空购物车
                // clearCartData();
                // 处理url
                location.href = res.Data;
            } else {
                // loading 关
                updateLoadingStatus(false);
                console.error("接口返回失败:", res);
                // 刷新页面
                location.reload();
            }
        })
        .catch((error) => {
            // loading 关
            updateLoadingStatus(false);
            console.error("提交失败:", error);
        });
}

// 异步函数，用于获取购物车数据
async function fetchCartData() {
    try {
        // 修改并设置 localization cookie 为 USD
        document.cookie = "localization=US; path=/"; // 设置 cookie，有效范围为整个网站

        const timestamp = getTimestamp();
        const response = await fetch(`/cart.js?t=${timestamp}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Cookie: "localization=US",
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        const cartData = await response.json(); // 解析返回的 JSON 数据
        return cartData; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 清空购物车数据
async function clearCartData() {
    try {
        const response = await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        const cartData = await response.json(); // 解析返回的 JSON 数据
        return cartData; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 添加购物车数据
async function addCartData(skuId, quantity) {
    try {
        const data = {
            items: [
                {
                    id: skuId, // skuid
                    quantity: quantity, // 数量
                },
            ],
        };
        const response = await fetch("cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error("Failed to fetch cart data");
        }

        // 使用 await 等待解析 JSON 数据
        return response; // 返回解析后的数据
    } catch (error) {
        // loading 关
        updateLoadingStatus(false);
        console.error("Error:", error.message);
        throw error;
    }
}

// 商品详情页执行逻辑
if (window.location.pathname.includes("/products/")) {
    // 获取商品详情页面的数据
    const productDetailElement = document.querySelector("[data-product-id]");

    // 获取商品的 ID
    if (productDetailElement) {
        const productId = productDetailElement.getAttribute("data-product-id");

        // 判断fir是否存在
        if (!getCookieValue("fir")) {
            // 获取pid
            var pids = getCookieValue("pid");
            if (pids && !pids.includes(productId)) {
                // 已存在，且不重复，则拼接
                pids += `,${productId}`;
            } else {
                // 不存在则设置
                pids = productId;
            }

            // 有效期为一天
            setCookieValue("pid", pids, getFutureDateTime(24 * 60));
        }

        // 判断缓存中是否重复，如果重复则不做接口提交
        var isRepetition = updateLocalStorageByType(productId, "click");
        if (!isRepetition) {
            const productIdArray = [productId];

            // 发送商品详情页点击请求
            const currentDomain = window.ShopifyStore?.handle ?? "";
            sendProductIdsToBackend(
                currentDomain,
                productIdArray,
                "Click",
                productIdArray
            );
        }
    }

    // 添加购物车按钮点击事件监听
    const formElement = document.querySelector("[data-product-id]");
    if (formElement) {
        // 获取表单中的按钮元素
        const addButton = document.querySelector(".product-form__buttons");
        // 确保按钮存在并且是有效的
        if (addButton) {
            // 监听按钮点击事件
            addButton.addEventListener("click", function (event) {
                //event.preventDefault(); // 防止表单提交（如果按钮类型为 submit）

                const productElement = document.querySelector("[data-product-id]");

                if (productElement) {
                    const productId = productElement.getAttribute("data-product-id");

                    // 判断缓存中是否重复，如果重复则不做接口提交
                    var isRepetition = updateLocalStorageByType(productId, "addToCart");
                    if (!isRepetition) {
                        const inputValueArray = [productId];
                        const domain = window.ShopifyStore?.handle ?? "";
                        sendProductIdsToBackend(
                            domain,
                            inputValueArray,
                            "AddToCart",
                            inputValueArray
                        );
                    }
                }
            });
        }
    }
}

// 购物车页执行逻辑
if (window.location.pathname.includes("/cart")) {
    // 获取所有结算按钮
    const cartButtons = document.querySelectorAll(".cart__checkout-button");

    // 遍历每个结算按钮
    cartButtons.forEach((cartButton) => {
        // 如果结算按钮已经存在，则清空已有的点击事件
        if (cartButton) {
            // 克隆结算按钮
            const newCartButton = cartButton.cloneNode(true);

            // 替换原按钮，移除原有的事件监听器
            cartButton.replaceWith(newCartButton);

            // 重新绑定点击事件
            newCartButton.addEventListener("click", async (event) => {
                event.preventDefault(); // 防止表单提交（如果按钮类型为 submit）
                event.stopImmediatePropagation(); // 防止其他点击事件触发

                // loading 开
                updateLoadingStatus(true);

                // 获取购物车数据
                const cartData = await fetchCartData();

                // 请求结算接口
                sendCart(cartData);
            });
        }
    });
}

// 分类商品页逻辑
if (window.location.pathname.includes("/collections/")) {
    // 获取翻页的a标签元素
    const currentPage = document.querySelectorAll(
        ".pagination ul li a.pagination__item"
    );

    // 通用处理函数
    function handlePaginationClick(event) {
        // 阻止默认跳转行为
        event.preventDefault();

        // const anchor = this.querySelector("a");
        const originalHref = this.getAttribute("href");
        // 去除 ?q=xxx 或 &q=xxx 参数
        let cleanedHref = originalHref
            .replace(/([&?])q=[^&]+/, "")
            .replace(/(&|\?)$/, "");
        // 如果剩余参数以 & 开头，改为 ?
        if (cleanedHref.includes("&") && !cleanedHref.includes("?")) {
            cleanedHref = cleanedHref.replace("&", "?");
        }
        // 执行跳转到清理后的地址
        window.location.href = cleanedHref;
    }

    // 添加事件监听
    for (var i = 0; i < currentPage.length; i++) {
        if (currentPage[i]) {
            currentPage[i].addEventListener("click", handlePaginationClick);
        }
    }
}

// 设置fir的cookie ，有效期20分钟
setCookieValue("fir", "1", getFutureDateTime(20));
// ----------------------------------------------------------------------
// 辅助函数：获取当前商品页面数据 (ViewContent 专用)
// ----------------------------------------------------------------------
function getProductDataForPixel() {
  // 确保 Shopify 全局统计对象存在
  if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.meta || !window.ShopifyAnalytics.meta.product) {
    return null;
  }

  const sa = window.ShopifyAnalytics;
  const product = sa.meta.product;

  // 1. 获取 ID逻辑：优先取 URL 里的 variant 参数，其次取默认选中变体，最后取商品主 ID
  // 这样能确保 FB 目录匹配最精准
  const urlParams = new URLSearchParams(window.location.search);
  let targetId = urlParams.get('variant') || sa.meta.selectedVariantId || product.id;

  // 2. 获取价格：Shopify 数据通常是分（如 2499），需要转为元（24.99）
  const price = (product.variants[0].price / 100).toFixed(2);

  return {
    content_ids: [targetId.toString()],      // 对应你的 cd[content_ids]
    content_name: product.title,             // 对应 cd[content_name]
    content_type: 'product',                 // 对应 cd[content_type]
    value: price,                            // 对应 cd[value]
    currency: sa.meta.currency || 'USD',     // 对应 cd[currency]
    content_category: product.type || ''     // 对应 cd[content_category]
  };
}

// ==================== 浮动联系按钮 & 表单窗口 ====================
(function initContactWidget() {
    // 避免重复初始化
    if (document.getElementById('goho-contact-root')) return;

    var isOpen = false;

    // --- 创建 SVG 图标 ---
    // 聊天气泡图标（关闭状态）
    var chatIconSVG = '<svg width="28" height="28" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>';

    // X 关闭图标（打开状态）
    var closeIconSVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M18 6L6 18M6 6l12 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

    // --- 注入样式 ---
    var style = document.createElement('style');
    style.textContent =
        '#goho-contact-root * { box-sizing: border-box; margin: 0; padding: 0; }' +

        // 浮动按钮
        '#goho-contact-btn {' +
        '  position: fixed; bottom: 70px; right: 24px; z-index: 2;' +
        '  width: 60px; height: 60px; border-radius: 50%; border: none;' +
        '  background: #6784a5;' +
        '  box-shadow: 0 4px 12px rgba(103,132,165,0.45), 0 2px 4px rgba(0,0,0,0.1);' +
        '  cursor: pointer; display: flex; align-items: center; justify-content: center;' +
        '  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;' +
        '  outline: none;' +
        '}' +
        '#goho-contact-btn:hover {' +
        '  transform: scale(1.1);' +
        '  box-shadow: 0 6px 20px rgba(103,132,165,0.6), 0 3px 6px rgba(0,0,0,0.15);' +
        '}' +
        '#goho-contact-btn:active { transform: scale(0.95); }' +
        '#goho-contact-btn .btn-icon { display: flex; align-items: center; justify-content: center; transition: transform 0.3s ease; pointer-events: none; }' +
        '#goho-contact-btn .btn-icon svg { pointer-events: none; }' +
        '#goho-contact-btn .btn-icon.rotate { transform: rotate(90deg); }' +

        // 表单窗口
        '#goho-contact-window {' +
        '  position: fixed; bottom: 142px; right: 24px; z-index: 2;' +
        '  width: 380px;' +
        '  background: #fff; border-radius: 16px;' +
        '  box-shadow: 0 8px 32px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.08);' +
        '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;' +
        '  opacity: 0; transform: translateY(20px) scale(0.95); pointer-events: none;' +
        '  transition: opacity 0.3s ease, transform 0.3s ease;' +
        '  overflow: hidden;' +
        '}' +
        '#goho-contact-window.visible {' +
        '  opacity: 1; transform: translateY(0) scale(1); pointer-events: auto;' +
        '}' +

        // 窗口头部
        '#goho-contact-window .window-header {' +
        '  background: linear-gradient(135deg, #4964D8 0%, #3B4FD4 100%);' +
        '  color: #fff; padding: 20px 24px 16px;' +
        '}' +
        '#goho-contact-window .window-header h3 { font-size: 16px; font-weight: 600; margin-bottom: 4px; }' +
        '#goho-contact-window .window-header p { font-size: 13px; opacity: 0.85; }' +

        // 表单内容
        '#goho-contact-window .window-body { padding: 20px 24px; overflow: visible; }' +
        '#goho-contact-window .form-group { margin-bottom: 14px; }' +
        '#goho-contact-window .form-group label {' +
        '  display: block; font-size: 14px; font-weight: 700; color: #333; margin-bottom: 6px;' +
        '}' +
        '#goho-contact-window .form-group label .required { color: #e74c3c; margin-left: 2px; }' +
        '#goho-contact-window .form-group select,' +
        '#goho-contact-window .form-group input,' +
        '#goho-contact-window .form-group textarea {' +
        '  width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px;' +
        '  font-size: 14px; color: #333; background: #fafafa;' +
        '  transition: border-color 0.2s ease, box-shadow 0.2s ease; outline: none;' +
        '}' +
        '#goho-contact-window .form-group select:focus,' +
        '#goho-contact-window .form-group input:focus,' +
        '#goho-contact-window .form-group textarea:focus {' +
        '  border-color: #4964D8; box-shadow: 0 0 0 3px rgba(73,100,216,0.12); background: #fff;' +
        '}' +
        '#goho-contact-window .form-group textarea { resize: vertical; min-height: 80px; }' +

        // 提交按钮
        '#goho-contact-window .submit-btn {' +
        '  width: 100%; padding: 12px; border: none; border-radius: 0; cursor: pointer;' +
        '  background: #000;' +
        '  color: #fff; font-size: 15px; font-weight: 600;' +
        '  transition: opacity 0.2s ease, transform 0.1s ease;' +
        '}' +
        '#goho-contact-window .submit-btn:hover { opacity: 0.9; }' +
        '#goho-contact-window .submit-btn:active { transform: scale(0.98); }' +
        '#goho-contact-window .submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }' +

        // 成功提示
        '#goho-contact-window .success-msg {' +
        '  text-align: center; padding: 32px 20px;' +
        '}' +
        '#goho-contact-window .success-msg .check-icon {' +
        '  width: 56px; height: 56px; border-radius: 50%;' +
        '  background: #e8f5e9; display: flex; align-items: center; justify-content: center;' +
        '  margin: 0 auto 16px;' +
        '}' +
        '#goho-contact-window .success-msg h4 { font-size: 18px; color: #333; margin-bottom: 8px; }' +
        '#goho-contact-window .success-msg p { font-size: 14px; color: #666; line-height: 1.5; }' +

        // 错误提示
        '#goho-contact-window .form-group .error-text { font-size: 12px; color: #e74c3c; margin-top: 4px; display: none; }' +
        '#goho-contact-window .form-group.has-error .error-text { display: block; }' +
        '#goho-contact-window .form-group.has-error input,' +
        '#goho-contact-window .form-group.has-error select,' +
        '#goho-contact-window .form-group.has-error textarea { border-color: #e74c3c; }' +

        // 移动端适配
        '@media (max-width: 480px) {' +
        '  #goho-contact-window { width: calc(100vw - 32px); right: 16px; bottom: 136px; }' +
        '  #goho-contact-btn { width: 52px; height: 52px; bottom: 62px; right: 16px; }' +
        '}';
    document.head.appendChild(style);

    // --- 创建根容器 ---
    var root = document.createElement('div');
    root.id = 'goho-contact-root';

    // --- 创建浮动按钮 ---
    var btn = document.createElement('button');
    btn.id = 'goho-contact-btn';
    btn.setAttribute('aria-label', 'Contact us');
    btn.innerHTML = '<span class="btn-icon">' + chatIconSVG + '</span>';

    // --- 创建表单窗口 ---
    var win = document.createElement('div');
    win.id = 'goho-contact-window';
    win.innerHTML =
        '<div class="window-body">' +
        '  <form id="goho-contact-form" novalidate>' +
        '    <div class="form-group">' +
        '      <label>Issue Type <span class="required">*</span></label>' +
        '      <select name="issueType" required>' +
        '        <option value="0" selected>Shipping</option>' +
        '        <option value="1">Refund</option>' +
        '        <option value="2">Product</option>' +
        '        <option value="3">AddressChange</option>' +
        '        <option value="99">Other</option>' +
        '      </select>' +
        '      <div class="error-text">Please select an issue type</div>' +
        '    </div>' +
        '    <div class="form-group">' +
        '      <label>Name <span class="required">*</span></label>' +
        '      <input type="text" name="name" placeholder="Your name" required />' +
        '      <div class="error-text">Please enter your name</div>' +
        '    </div>' +
        '    <div class="form-group">' +
        '      <label>Order Email <span class="required">*</span></label>' +
        '      <input type="email" name="email" placeholder="your@email.com" required />' +
        '      <div class="error-text">Please enter a valid email address</div>' +
        '    </div>' +
        '    <div class="form-group">' +
        '      <label>Order Number</label>' +
        '      <input type="text" name="orderNumber" placeholder="e.g. #12345" />' +
        '    </div>' +
        '    <div class="form-group">' +
        '      <label>Message <span class="required">*</span></label>' +
        '      <textarea name="message" placeholder="Describe your issue or question..." rows="4" required></textarea>' +
        '      <div class="error-text">Please enter your message</div>' +
        '    </div>' +
        '    <button type="submit" class="submit-btn">Submit</button>' +
        '  </form>' +
        '</div>';

    root.appendChild(btn);
    root.appendChild(win);
    document.body.appendChild(root);

    // --- 点击外部关闭窗口 ---
    document.addEventListener('click', function (e) {
        if (!isOpen) return;
        if (btn.contains(e.target) || win.contains(e.target)) return;
        isOpen = false;
        var iconEl = btn.querySelector('.btn-icon');
        iconEl.innerHTML = chatIconSVG;
        iconEl.classList.remove('rotate');
        win.classList.remove('visible');
    });

    // --- 按钮点击切换 ---
    btn.addEventListener('click', function () {
        isOpen = !isOpen;
        var iconEl = btn.querySelector('.btn-icon');
        if (isOpen) {
            iconEl.innerHTML = closeIconSVG;
            iconEl.classList.add('rotate');
            win.classList.add('visible');
        } else {
            iconEl.innerHTML = chatIconSVG;
            iconEl.classList.remove('rotate');
            win.classList.remove('visible');
        }
    });

    // --- 表单验证 & 提交 ---
    var form = document.getElementById('goho-contact-form');
    form.addEventListener('submit', function (e) {
        e.preventDefault();

        // 清除之前的错误状态
        var groups = form.querySelectorAll('.form-group');
        groups.forEach(function (g) { g.classList.remove('has-error'); });

        var issueType = form.issueType.value.trim();
        var name = form.name.value.trim();
        var email = form.email.value.trim();
        var orderNumber = form.orderNumber.value.trim();
        var message = form.message.value.trim();

        var valid = true;

        if (!issueType) { form.issueType.closest('.form-group').classList.add('has-error'); valid = false; }
        if (!name) { form.name.closest('.form-group').classList.add('has-error'); valid = false; }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { form.email.closest('.form-group').classList.add('has-error'); valid = false; }
        if (!message) { form.message.closest('.form-group').classList.add('has-error'); valid = false; }

        if (!valid) return;

        // 禁用提交按钮
        var submitBtn = form.querySelector('.submit-btn');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        // 获取店铺 handle
        var handle = window.ShopifyStore?.handle || '';

        fetch('https://goho.work/api/contact/submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
                email: email,
                customerName: name,
                note: message,
                orderId: orderNumber,
                contactType: parseInt(issueType, 10)
            })
        })
            .then(function (res) {
                if (res.status === 200) {
                    return res.json().then(function () { return true; }).catch(function () { return true; });
                }
                throw new Error('HTTP ' + res.status);
            })
            .then(function () {
                // 显示成功状态
                var bodyEl = win.querySelector('.window-body');
                // 从页面已有的 asset 链接中提取基础路径
                var assetBase = '';
                var assetLink = document.querySelector('link[href*="/assets/"]');
                if (assetLink) {
                    var match = assetLink.getAttribute('href').match(/(.+\/assets\/)[^/]+/);
                    if (match) assetBase = match[1];
                }
                var successImgUrl = assetBase ? assetBase + 'success.png' : '';
                bodyEl.innerHTML =
                    '<div class="success-msg">' +
                    '  <img src="' + successImgUrl + '" style="width:80px;margin:0 auto 20px;display:block;" />' +
                    '  <h4>Thank You!</h4>' +
                    '  <p>Your message has been sent successfully. We\'ll get back to you as soon as possible.</p>' +
                    '</div>';
            })
            .catch(function (err) {
                console.error('Contact form submission failed:', err);
                submitBtn.disabled = false;
                submitBtn.textContent = 'Submit';
                alert('Submission failed, please try again later.');
            });
    });
})();